import { Button, type TpButtonProps } from '@mentalgrowth/ui-kit-web';
import classNames from 'classnames';

import styles from './UiKitButton.module.css';

export const UiKitButton = (props: TpButtonProps) => {
  const { className, ...otherProps } = props;
  return (
    <Button className={classNames(styles.button, className)} {...otherProps} />
  );
};
